import { render, staticRenderFns } from "./prod-dets.vue?vue&type=template&id=28d52d6a&scoped=true&"
import script from "./prod-dets.vue?vue&type=script&lang=js&"
export * from "./prod-dets.vue?vue&type=script&lang=js&"
import style0 from "./prod-dets.vue?vue&type=style&index=0&id=28d52d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d52d6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
